import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getDiagnosisSelector } from '../selectors'
import { IDiagnosisState } from '../store/diagnosis.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { DiagnosisConstants } from '../store/diagnosis.constants'

export function* saveDiagnosis() {
  const diagnosis: IDiagnosisState = yield select(getDiagnosisSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      diagnosis,
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveDiagnosis() error: ${e}`))
    }
  }
}

export function* saveDiagnosisSaga() {
  yield takeLatest(
    [
      DiagnosisConstants.SET_INITIAL_PATIENT_ACUITY,
      DiagnosisConstants.SET_INITIAL_PATIENT_ACUITY_PNNV,
      DiagnosisConstants.SET_ORGAN_SYSTEM,
      DiagnosisConstants.SET_ORGAN_SYSTEM_PNNV,
      DiagnosisConstants.SET_SYMPTOMS,
      DiagnosisConstants.SET_IMPRESSIONS,
      DiagnosisConstants.SET_IMPRESSIONS_PNNV,
      DiagnosisConstants.SET_ANATOMIC_LOCATION,
      DiagnosisConstants.SET_ANATOMIC_LOCATION_PNNV,
      DiagnosisConstants.SET_FINAL_PATIENT_ACUITY,
      DiagnosisConstants.SET_FINAL_PATIENT_ACUITY_PNNV,
      DiagnosisConstants.SET_WORKING_DIAGNOSIS,
      DiagnosisConstants.SET_CONDITION_AT_DESTINATION,
    ],
    performWithMutexHOG,
    saveDiagnosis
  )
}
